import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Alert } from '@mui/material';
import { authAPI } from '../services/api';
import { errorText } from '../utils/format';

export default function ChangePasswordDialog({ open, onClose }) {
  const [form, setForm] = useState({ current: '', next: '', again: '' });
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const close = () => { setForm({ current: '', next: '', again: '' }); setError(''); setDone(false); onClose(); };

  const save = async () => {
    setError('');
    if (!form.current) return setError('Enter your current password.');
    if (form.next.length < 6) return setError('The new password must be at least 6 characters.');
    if (form.next !== form.again) return setError('The new passwords do not match.');
    setBusy(true);
    try {
      await authAPI.changePassword(form.current, form.next);
      setDone(true);
    } catch (e) { setError(errorText(e, 'Could not change the password.')); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Change password</DialogTitle>
      <DialogContent>
        {done ? (
          <Alert severity="success" sx={{ mt: 1 }}>Password changed. Use the new password the next time you sign in.</Alert>
        ) : (
          <>
            {error && <Alert severity="error" sx={{ mb: 2, mt: 1 }}>{error}</Alert>}
            <TextField fullWidth type="password" label="Current password" margin="dense" autoComplete="current-password"
              value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} />
            <TextField fullWidth type="password" label="New password (at least 6 characters)" margin="dense" autoComplete="new-password"
              value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} />
            <TextField fullWidth type="password" label="Repeat the new password" margin="dense" autoComplete="new-password"
              value={form.again} onChange={(e) => setForm({ ...form, again: e.target.value })}
              onKeyDown={(e) => { if (e.key === 'Enter') save(); }} />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={close}>{done ? 'Close' : 'Cancel'}</Button>
        {!done && <Button variant="contained" onClick={save} disabled={busy}>Change password</Button>}
      </DialogActions>
    </Dialog>
  );
}
